<template>
  <v-container id="web" tag="section">
    <base-v-component heading="Diseño web propio del negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          :loading="loadingForm"
          dark
          class="mb-2"
          @click.stop="save()"
          >Guardar</v-btn
        >
        <v-spacer />
        <traducciones-dialog
          :datos="valoresTraducir"
          @camposTraducidos="camposTraducidos"
        />

        <v-select
          :items="idiomas"
          hide-details=""
          v-model="langSeleccionado"
          label="Selección idioma"
          outline
        ></v-select>
      </v-toolbar>
      <v-tabs
        vertical
        background-color="deep-purple accent-4"
        center-active
        dark
        v-model="tab"
      >
        <v-tab key="conf">Configuración</v-tab>
        <v-tab key="pwa">PWA</v-tab>
        <v-tab key="plantilla">Plantilla</v-tab>
        <v-tab key="inicio">Inicio</v-tab>
        <v-tab key="pedir">Pedir</v-tab>
        <v-tab key="domicilio">Domicilio</v-tab>
        <v-tab key="recoger">Recoger</v-tab>
        <v-tab key="finalizar">Finalizar</v-tab>
        <v-tab key="encuentranos">Encuentranos</v-tab>
        <v-tab key="reservas">Reservas</v-tab>
        <v-tab key="noticias">Noticias</v-tab>
        <v-tab key="dinamicas">dinámicas</v-tab>

        <v-tabs-items v-model="tab">
          <v-tab-item key="conf">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >Configuración</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-row class="pa-4">
                <v-col cols="12" sm="3">
                  <v-text-field label="Router" v-model="configuracion.router" />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field label="GTAG" v-model="configuracion.gtag" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="datosGeneralesDominios"
                    label="Dominios"
                    placeholder="separados por comas"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Pixel Facebook"
                    v-model="configuracion.pixelFb"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Pixel Tiktok"
                    v-model="configuracion.pixelTiktok"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    multiple
                    label="Idiomas"
                    :items="idiomas"
                    v-model="configuracion.idiomas"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- INICIO ITEM PWA-->
          <v-tab-item key="pwa">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-row align="center">
                  <v-toolbar-title class="white--text">PWA</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="generarManifest"
                    class="secondary"
                    :loading="loadingForm"
                    >Generar manifest.json</v-btn
                  >
                </v-row>
              </v-toolbar>
              <v-row class="px-4">
                <!-- <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Logo</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="pwa.logo"
                      @click="pwa.logo = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('logo')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="logo"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('pwa')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="pwa.logo" max-height="150px" />
                </v-col> -->

                <v-col cols="12" sm="4">
                  <v-text-field v-model="pwa.nombre" label="Nombre PWA" />
                </v-col>
                <v-col cols="12" sm="8">
                  <v-text-field
                    v-model="pwa.descripcion"
                    label="Descripción PWA"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Icono 192</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="pwa.icono192"
                      @click="pwa.icono192 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('icono192')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="icono192"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Icono 192"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('pwa')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="pwa.icono192" max-height="150px" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Icono 512</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="pwa.icono512"
                      @click="pwa.icono512 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('icono512')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="icono512"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Icono 192"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('pwa')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="pwa.icono512" max-height="150px" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="pwa.icono192" label="Icono 192x192" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="pwa.icono512" label="Icono 512x512" />
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-center subtitle-1">Color tema</p>
                  <v-color-picker
                    hide-canvas
                    v-model="pwa.colorTema"
                  ></v-color-picker>
                </v-col>
                <v-col cols="12" sm="6">
                  <p class="text-center subtitle-1">Color fondo</p>
                  <v-color-picker
                    hide-canvas
                    v-model="pwa.colorFondo"
                  ></v-color-picker>
                </v-col>
                <v-divider />
                <v-row>
                  <h5>Imágenes iOS</h5>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iphone5"
                      @imagen-subida="imagenSubidaPwaSplash($event, 'iphone5')"
                      :propImg="pwa.splash.iphone5"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iphone6"
                      @imagen-subida="imagenSubidaPwaSplash($event, 'iphone6')"
                      :propImg="pwa.splash.iphone6"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iphoneplus"
                      @imagen-subida="
                        imagenSubidaPwaSplash($event, 'iphoneplus')
                      "
                      :propImg="pwa.splash.iphoneplus"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iphonex"
                      @imagen-subida="imagenSubidaPwaSplash($event, 'iphonex')"
                      :propImg="pwa.splash.iphonex"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iphonexr"
                      @imagen-subida="imagenSubidaPwaSplash($event, 'iphonexr')"
                      :propImg="pwa.splash.iphonexr"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iphonexsmax"
                      @imagen-subida="
                        imagenSubidaPwaSplash($event, 'iphonexsmax')
                      "
                      :propImg="pwa.splash.iphonexsmax"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <input-subir-imagen
                      nombre="Imagen Splash iPad"
                      @imagen-subida="imagenSubidaPwaSplash($event, 'ipad')"
                      :propImg="pwa.splash.ipad"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- FIN ITEM PWA-->
          <!-- INICIO ITEM GENERAL-->
          <v-tab-item key="plantilla">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">Plantilla</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-row class="px-4">
                <v-col cols="12" sm="3">
                  <v-switch v-model="general.darkDrawer" label="Dark Drawer" />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-switch v-model="general.darkFooter" label="Dark Footer" />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-switch v-model="general.darkHeader" label="Dark Header" />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-switch
                    v-model="general.darkMenuUser"
                    label="Dark Menu Usuario"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.colorPrimary"
                    messages="hexadecimal poner #"
                    label="Color Primary"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.colorSecondary"
                    messages="hexadecimal poner #"
                    label="Color Secondary"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.colorFooter"
                    label="Color Footer"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.colorMenuUser"
                    label="Color Menu User"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.fondoDrawer"
                    label="Fondo Drawer"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.fondoHeader"
                    label="Fondo Header"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.menuUserActivoClases"
                    label="Clase menu usuario"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="general.nombreFooter"
                    label="Nombre Footer"
                  />
                </v-col>
              </v-row>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="general.redesSociales.facebook"
                    label="Enlace Facebook"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="general.redesSociales.twitter"
                    label="Enlace Twitter"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="general.redesSociales.instagram"
                    label="Enlace Instagram"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="general.redesSociales.tiktok"
                    label="Enlace Tiktok"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="general.redesSociales.youtube"
                    label="Enlace Youtube"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-checkbox
                    v-model="general.msjInicial.mostrar"
                    label="Mostrar mensaje inicial"
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    :value="valorVariableIdioma('general.msjInicial.titulo')"
                    @input="
                      valorVariableIdiomaCambio(
                        $event,
                        'general.msjInicial.titulo'
                      )
                    "
                    label="titulo"
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <v-textarea
                    :value="valorVariableIdioma('general.msjInicial.texto')"
                    @input="
                      valorVariableIdiomaCambio(
                        $event,
                        'general.msjInicial.texto'
                      )
                    "
                    label="Mensaje"
                  />
                </v-col>
              </v-row>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Logo izquierda</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="general.logoIzquierda"
                      @click="general.logoIzquierda = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('logoIzquierda')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="logoIzquierda"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero(false)"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="general.logoIzquierda" max-height="150px" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Logo centro</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="general.logoCentro"
                      @click="general.logoCentro = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('logoCentro')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="logoCentro"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero(false)"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="general.logoCentro" max-height="150px" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Bolsa carrito</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="general.bolsaCarrito"
                      @click="general.bolsaCarrito = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('bolsaCarrito')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="bolsaCarrito"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero(false)"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="general.bolsaCarrito" max-height="150px" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Favicon</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="general.favicon"
                      @click="general.favicon = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('favicon')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="favicon"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero(false)"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="general.favicon" max-height="150px" />
                </v-col>
                <!-- seo item 1-->
                <v-row>
                  <v-col cols="12">
                    <v-card color="#385F73" dark>
                      <v-card-title class="headline white--text"
                        >SEO</v-card-title
                      >

                      <v-row class="px-4">
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="general.seo.ogtitle"
                            label="OG Title (redes sociales)"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="general.seo.ogtype"
                            label="OG Tipo (website)"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="general.seo.robots"
                            label="Robot (index,follow)"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="general.seo.titleTemplate"
                            label="Plantilla titulo (%s - Negocio)"
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-btn text @click="generarSitemap"
                            >Generar sitemap</v-btn
                          >
                          <v-textarea
                            clearable
                            clear-icon="mdi-close"
                            v-model="general.seo.sitemap"
                            label="Sitemap"
                          />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-card>
            <!-- FIN ITEM GENERAL-->
          </v-tab-item>
          <!-- INICIO ITEM HOME -->
          <v-tab-item key="inicio">
            <!-- INICIO SECCIÓN 1-->
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-row align="center">
                  <v-toolbar-title class="white--text"
                    >Sección 1 - Slider
                  </v-toolbar-title>
                  <v-switch
                    class="ml-6 white--text"
                    color="secondary"
                    v-model="home.seccion1.mostrar"
                    label="Mostrar"
                  />
                  <v-spacer></v-spacer>
                </v-row>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-card>
                    <v-card-title
                      >Botones portada<v-card-actions
                        ><v-icon @click="addBoton('seccion1')"
                          >mdi-plus</v-icon
                        ></v-card-actions
                      ></v-card-title
                    >
                    <v-card-text>
                      <v-list dense>
                        <v-list-item
                          v-for="(l, i) in home.seccion1.botones"
                          :key="i"
                        >
                          <v-list-item-content class="ma-0 pa-0">
                            <v-col cols="5" class="pa-0 ma-0 pr-1">
                              <v-text-field
                                label="texto"
                                @input="
                                  valorVariableIdiomaCambio(
                                    $event,
                                    'home.seccion1.botones.' + i + '].texto'
                                  )
                                "
                                :value="
                                  valorVariableIdioma(
                                    'home.seccion1.botones[' + i + '].texto'
                                  )
                                "
                              />
                            </v-col>
                            <v-col cols="5" class="pa-0 ma-0">
                              <v-text-field label="enlace" v-model="l.enlace" />
                            </v-col>
                            <v-col cols="2" class="pa-0 ma-0">
                              <v-icon
                                @click="eliminarBoton(l, 'seccion1')"
                                color="red"
                                >mdi-delete</v-icon
                              >
                            </v-col>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="subtitle-1">Color botón texto</span>
                  <v-color-picker
                    v-model="home.seccion1.botonColorTexto"
                    label="Color botón texto"
                  ></v-color-picker>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="subtitle-1">Color botón fondo</span>

                  <v-color-picker
                    v-model="home.seccion1.botonColorFondo"
                    label="Color botón fondo"
                  ></v-color-picker>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio(
                        $event,
                        'home.seccion1.textoAccion'
                      )
                    "
                    :value="valorVariableIdioma('home.seccion1.textoAccion')"
                    label="texto acción imagen"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="home.seccion1.estiloImagen"
                    label="Estilo gradiente imagen"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">
                      Imagen sobre los botones
                    </p>

                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion1.imagenSobreBotones"
                      @click="home.seccion1.imagenSobreBotones = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('imagenSobreBotones')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="imagenSobreBotones"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion1')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion1.imagenSobreBotones"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Slide 1</p>

                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion1.slider.slide1"
                      @click="home.seccion1.slider.slide1 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('slide1')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="slide1"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion1/slider')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion1.slider.slide1"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Slide 2</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion1.slider.slide2"
                      @click="home.seccion1.slider.slide2 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('slide2')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="slide2"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion1/slider')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion1.slider.slide2"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Slide 3</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion1.slider.slide3"
                      @click="home.seccion1.slider.slide3 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('slide3')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="slide3"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion1/slider')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion1.slider.slide3"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Slide 4</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion1.slider.slide4"
                      @click="home.seccion1.slider.slide4 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('slide4')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="slide4"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion1/slider')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion1.slider.slide4"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Slide 5</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion1.slider.slide5"
                      @click="home.seccion1.slider.slide5 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('slide5')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="slide5"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion1/slider')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion1.slider.slide5"
                    max-height="150px"
                  />
                </v-col>
              </v-row>
            </v-card>
            <!-- FIN SECCIÓN 1-->
            <!-- INICIO SECCIÓN 2-->
            <v-card class="px-4">
              <v-toolbar color="primary" dark dense>
                <v-toolbar-title class="white--text"
                  >Sección 2 - (Por ejemplo App Móvil)</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-switch v-model="home.seccion2.mostrar" label="Mostrar" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Imagen</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion2.imagen"
                      @click="home.seccion2.imagen = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('imagen')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="imagen"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion2')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="home.seccion2.imagen" max-height="150px" />
                </v-col>
              </v-row>
            </v-card>
            <!-- FIN SECCIÓN 2-->
            <!-- INICIO SECCIÓN 3-->
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >Sección 3 - (Por ejemplo Franquíciate)</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-switch v-model="home.seccion3.mostrar" label="Mostrar" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Imagen</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion3.imagenSeccion3"
                      @click="home.seccion3.imagenSeccion3 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('imagenSeccion3')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="imagenSeccion3"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion3')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion3.imagenSeccion3"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio($event, 'home.seccion3.h1')
                    "
                    :value="valorVariableIdioma('home.seccion3.h1')"
                    label="Texto h1"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio($event, 'home.seccion3.h2')
                    "
                    :value="valorVariableIdioma('home.seccion3.h2')"
                    label="Texto h2"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio($event, 'home.seccion3.h4')
                    "
                    :value="valorVariableIdioma('home.seccion3.h4')"
                    label="Texto h4"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio(
                        $event,
                        'home.seccion3.botonTexto'
                      )
                    "
                    :value="valorVariableIdioma('home.seccion3.botonTexto')"
                    label="Texto boton"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="home.seccion3.botonEnlace"
                    label="Enlace boton"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-card>
                    <v-card-title
                      >Botones sección 3<v-card-actions
                        ><v-icon @click="addBoton('seccion3')"
                          >mdi-plus</v-icon
                        ></v-card-actions
                      ></v-card-title
                    >
                    <v-card-text>
                      <v-list dense>
                        <v-list-item
                          v-for="(l, i) in home.seccion3.botones"
                          :key="i"
                        >
                          <v-list-item-content class="ma-0 pa-0">
                            <v-col cols="5" class="pa-0 ma-0 pr-1">
                              <v-text-field
                                label="texto"
                                @input="
                                  valorVariableIdiomaCambio(
                                    $event,
                                    'home.seccion3.botones[' + i + '].texto'
                                  )
                                "
                                :value="
                                  valorVariableIdioma(
                                    'home.seccion3.botones[' + i + '].texto'
                                  )
                                "
                              />
                            </v-col>
                            <v-col cols="5" class="pa-0 ma-0">
                              <v-text-field label="enlace" v-model="l.enlace" />
                            </v-col>
                            <v-col cols="2" class="pa-0 ma-0">
                              <v-icon
                                @click="eliminarBoton(l, 'seccion3')"
                                color="red"
                                >mdi-delete</v-icon
                              >
                            </v-col>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
            <!-- INICIO SECCIÓN 7-->
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >Sección 7 - (Listado Restaurants parallax)</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-switch v-model="home.seccion7.mostrar" label="Mostrar" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2"> </v-row>
                </v-col> </v-row
            ></v-card>
            <!-- FIN SECCIÓN 7-->

            <!-- INICIO SECCIÓN 4 FORM CONTACTO-->
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >Sección 4 - (Formulario de contacto)</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-switch v-model="home.seccion4.mostrar" label="Mostrar" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    label="Mensaje alerta formulario"
                    v-model="home.seccion4.alertpersonalizado"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Imagen</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="home.seccion4.imagenSeccion4"
                      @click="home.seccion4.imagenSeccion4 = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('imagenSeccion4')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="imagenSeccion4"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion4')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="home.seccion4.imagenSeccion4"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="subtitle-1">Color fondo si no tiene imagen</span>
                  <v-color-picker
                    v-model="home.seccion4.colorFondo"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </v-card>
            <!-- FIN SECCIÓN 4-->
            <!-- INICIO SECCIÓN 5 CAROUSEL SPONSORS-->
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >Sección 5 - (Slider Sponsors)</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-switch v-model="home.seccion5.mostrar" label="Mostrar" />
                </v-col>
              </v-row>
              <v-row class="px-4">
                <v-col cols="12" sm="6">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio($event, 'home.seccion5.titulo')
                    "
                    :value="valorVariableIdioma('home.seccion5.titulo')"
                    label="Título"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio(
                        $event,
                        'home.seccion5.subtitulo'
                      )
                    "
                    :value="valorVariableIdioma('home.seccion5.subtitulo')"
                    label="Subtítulo"
                  />
                </v-col>
                <v-col cols="12">
                  <v-row align="center" justify="start">
                    <draggable
                      v-model="home.seccion5.arrayImagenes"
                      style="display: flex"
                    >
                      <v-card
                        max-width="300px"
                        :key="i"
                        v-for="(img, i) in home.seccion5.arrayImagenes"
                      >
                        <v-img
                          :key="i"
                          class="mx-2"
                          max-width="100px"
                          height="50px"
                          :src="img.imagenUrl"
                        />

                        <v-card-text>
                          <v-col cols="12">
                            <v-text-field v-model="img.nombre" label="nombre"
                          /></v-col>
                          <v-col cols="12">
                            <v-text-field v-model="img.enlace" label="Enlace"
                          /></v-col>
                          <v-col cols="10" class="">
                            <v-btn class="red" @click="borrarArrayImagen(i)"
                              >Borrar</v-btn
                            >
                          </v-col>
                        </v-card-text>
                      </v-card>
                    </draggable>
                    <v-card
                      height="50px"
                      width="50px"
                      small
                      class="primary"
                      @click="cambiarImagen('arrayImagenes')"
                    >
                      <v-card-title class="text--white">
                        <v-icon class="text--white">mdi-plus</v-icon>
                      </v-card-title>
                    </v-card>
                    <v-file-input
                      class="d-none"
                      ref="arrayImagenes"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('home/seccion5')"
                      :show-size="1000"
                    />
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4"> </v-col>
              </v-row>
            </v-card>
            <!-- FIN SECCIÓN 5-->
            <!-- INICIO SECCIÓN 6 INSTAGRAM FEED-->
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >Sección 6 - INSTAGRAM FEED</v-toolbar-title
                >
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-switch v-model="home.seccion6.mostrar" label="Mostrar" />
                </v-col>
              </v-row>
              <v-row class="px-4">
                <v-col cols="12" sm="6">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio($event, 'home.seccion6.titulo')
                    "
                    :value="valorVariableIdioma('home.seccion6.titulo')"
                    label="Título"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    @input="
                      valorVariableIdiomaCambio(
                        $event,
                        'home.seccion6.subtitulo'
                      )
                    "
                    :value="valorVariableIdioma('home.seccion6.subtitulo')"
                    label="Subtítulo"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="home.seccion6.nombreUsuario"
                    label="Nombre de usuario Instagram"
                  />
                </v-col>
              </v-row>
            </v-card>
            <!-- FIN SECCIÓN 6-->
            <!-- seo item 2-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio($event, 'home.seo.title')
                        "
                        :value="valorVariableIdioma('home.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'home.seo.description'
                          )
                        "
                        :value="valorVariableIdioma('home.seo.description')"
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM HOME -->
          <!-- INICIO ITEM PEDIR-->
          <v-tab-item key="pedir">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">PEDIR</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Bolsa en carrito</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="pedir.bolsaCarritoCategoriasImagen"
                      @click="pedir.bolsaCarritoCategoriasImagen = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('bolsaCarritoCategoriasImagen')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="bolsaCarritoCategoriasImagen"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('pedir')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="pedir.bolsaCarritoCategoriasImagen"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Fondo Imagen</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="pedir.fondoImagen"
                      @click="pedir.fondoImagen = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('fondoImagen')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="fondoImagen"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('pedir')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="pedir.fondoImagen" max-height="150px" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="pedir.fondoColor"
                    label="Color de fondo productos"
                  />
                </v-col>
              </v-row>
            </v-card>
            <!-- seo item 3-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio($event, 'pedir.seo.title')
                        "
                        :value="valorVariableIdioma('pedir.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'pedir.seo.description'
                          )
                        "
                        :value="valorVariableIdioma('pedir.seo.description')"
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM PEDIR-->
          <!-- INICIO ITEM DOMICILIO-->
          <v-tab-item key="domicilio">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">DOMICILIO</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4"></v-row>
            </v-card>
            <!-- seo item DOMICILIO-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'domicilio.seo.title'
                          )
                        "
                        :value="valorVariableIdioma('domicilio.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'domicilio.seo.description'
                          )
                        "
                        :value="
                          valorVariableIdioma('domicilio.seo.description')
                        "
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM DOMICILIO-->
          <!-- INICIO ITEM RECOGER-->
          <v-tab-item key="recoger">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">RECOGER</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4"></v-row>
            </v-card>
            <!-- seo item RECOGER-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio($event, 'recoger.seo.title')
                        "
                        :value="valorVariableIdioma('recoger.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'recoger.seo.description'
                          )
                        "
                        :value="valorVariableIdioma('recoger.seo.description')"
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM RECOGER-->
          <!-- INICIO ITEM FINALIZAR-->
          <v-tab-item key="finalizar">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">FINALIZAR</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="px-4">
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">Fondo formas de pago</p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="finalizar && finalizar.fondoFormasPago"
                      @click="finalizar.fondoFormasPago = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('fondoFormasPago')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="fondoFormasPago"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('finalizar')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="finalizar && finalizar.fondoFormasPago"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">
                      Logo encima formas de pago
                    </p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="finalizar.logo"
                      @click="finalizar.logo = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('logo')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="logo"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('finalizar')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img :src="finalizar.logo" max-height="150px" />
                </v-col>
              </v-row>
            </v-card>
            <!-- seo item 4-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'finalizar.seo.title'
                          )
                        "
                        :value="valorVariableIdioma('finalizar.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'finalizar.seo.description'
                          )
                        "
                        :value="
                          valorVariableIdioma('finalizar.seo.description')
                        "
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM FINALIZAR-->
          <!-- INICIO ITEM ENCUENTRANOS-->
          <v-tab-item key="encuentranos">
            <v-row>
              <v-col cols="12">
                <v-card class="px-4">
                  <v-toolbar color="primary" dense>
                    <v-toolbar-title class="white--text"
                      >ENCUENTRANOS</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-row class="px-4">
                    <v-col cols="12" sm="4">
                      <v-switch
                        v-model="encuentranos.activo"
                        label="Sección activa"
                      />
                    </v-col>
                    <v-col cols="12" sm="8">
                      <v-text-field
                        label="Icono mapa"
                        v-model="encuentranos.iconoMapa"
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-row class="mx-2">
                        <p class="text-center subtitle-1">Imagen</p>
                        <v-spacer />
                        <v-btn
                          :loading="loadingImagenAux"
                          small
                          class="red mr-4"
                          v-if="encuentranos.imagenFondo"
                          @click="encuentranos.imagenFondo = ''"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-btn
                          :loading="loadingImagenAux"
                          small
                          class="secondary"
                          @click="cambiarImagen('imagenFondo')"
                        >
                          <v-icon>mdi-reload</v-icon>
                        </v-btn>
                        <v-file-input
                          class="d-none"
                          ref="imagenFondo"
                          color="deep-purple accent-4"
                          counter
                          label="File input"
                          placeholder="Select your files"
                          prepend-icon="mdi-paperclip"
                          outlined
                          v-model="imagenAux"
                          @change="cambiarImagenFichero('encuentranos')"
                          :show-size="1000"
                        />
                      </v-row>
                      <v-img
                        :src="encuentranos.imagenFondo"
                        max-height="150px"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="2">
                      <v-text-field
                        label="Color HEX btn pedir"
                        v-model="encuentranos.colorBtnPedir"
                      />
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field
                        label="Color HEX btn carta"
                        v-model="encuentranos.colorBtnCarta"
                      />
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field
                        label="Color HEX btn horarios"
                        v-model="encuentranos.colorBtnHorarios"
                      />
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field
                        label="Color HEX btn pedir texto"
                        v-model="encuentranos.colorBtnPedirTexto"
                      />
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field
                        label="Color HEX btn carta texto"
                        v-model="encuentranos.colorBtnCartaTexto"
                      />
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field
                        label="Color HEX btn horarios texto"
                        v-model="encuentranos.colorBtnHorariosTexto"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        label="Imagen superior"
                        v-model="encuentranos.imagenSuperior"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        label="Imagen inferior"
                        v-model="encuentranos.imagenInferior"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- seo item ENCUENTRANOS-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'encuentranos.seo.title'
                          )
                        "
                        :value="valorVariableIdioma('encuentranos.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'encuentranos.seo.description'
                          )
                        "
                        :value="
                          valorVariableIdioma('encuentranos.seo.description')
                        "
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM ENCUENTRANOS-->
          <!-- INICIO ITEM RESERVAS-->
          <v-tab-item key="reservas">
            <v-row>
              <v-col cols="12">
                <v-card class="px-4">
                  <v-toolbar color="primary" dense>
                    <v-toolbar-title class="white--text"
                      >RESERVAS</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-row class="px-4">
                    <v-col cols="12" sm="4">
                      <v-switch
                        v-model="reservas.activo"
                        label="Sección activa"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- seo item RESERVAS-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'reservas.seo.title'
                          )
                        "
                        :value="valorVariableIdioma('reservas.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'reservas.seo.description'
                          )
                        "
                        :value="valorVariableIdioma('reservas.seo.description')"
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM RESERVAS-->
          <!-- INICIO ITEM NOTICIAS-->
          <v-tab-item key="noticias">
            <v-row>
              <v-col cols="12">
                <v-card class="px-4">
                  <v-toolbar color="primary" dense>
                    <v-toolbar-title class="white--text"
                      >NOTICIAS</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-row class="px-4">
                    <v-col cols="12" sm="4">
                      <v-switch
                        v-model="noticias.activo"
                        label="Sección activa"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- seo item NOTICIAS-->
            <v-row>
              <v-col cols="12">
                <v-card color="#385F73" dark>
                  <v-card-title class="headline white--text">SEO</v-card-title>

                  <v-row class="px-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'noticias.seo.title'
                          )
                        "
                        :value="valorVariableIdioma('noticias.seo.title')"
                        label="Título"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        @input="
                          valorVariableIdiomaCambio(
                            $event,
                            'noticias.seo.description'
                          )
                        "
                        :value="valorVariableIdioma('noticias.seo.description')"
                        label="Descripción"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- FIN ITEM NOTICIAS-->
          <!-- INICIO ITEM DINÁMICAS-->
          <v-tab-item key="dinamicas">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >PAGINAS DINÁMICAS</v-toolbar-title
                >
                <v-spacer />
                <v-btn text class="secondary" @click="goAddPagina"
                  >Añadir página</v-btn
                >
              </v-toolbar>

              <v-row class="px-4">
                <v-col cols="12">
                  <v-data-table
                    :items="paginasDinamicas"
                    :headers="headersPaginas"
                  >
                    <template v-slot:item.acciones="{ item }">
                      <v-card-actions class="pa-0 ma-0">
                        <v-spacer></v-spacer>
                        <v-tooltip top v-if="item.activo">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="px-2 ml-1"
                              color="green"
                              min-width="0"
                              :loading="loadingActivo"
                              small
                              v-on="on"
                              @click="cambiarActivo(item)"
                            >
                              <v-icon small>mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>Desactivar</span>
                        </v-tooltip>
                        <v-tooltip top v-else>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="px-2 ml-1"
                              :loading="loadingActivo"
                              color="red"
                              min-width="0"
                              small
                              v-on="on"
                              @click="cambiarActivo(item)"
                            >
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Activar</span>
                        </v-tooltip>
                        <v-btn
                          class="px-2 ml-1"
                          color="secondary"
                          min-width="0"
                          small
                          @click="goEdit(item)"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="loadingEliminar"
                          @click="deleteItem(item)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- FIN ITEM DINAMICAS-->
        </v-tabs-items>
      </v-tabs>
    </base-material-card>
  </v-container>
</template>

<script>
const getValue = (obj, path) => {
  if (!path) return obj;
  const properties = path.split(".");
  return getValue(obj[properties.shift()], properties.join("."));
};

import draggable from "vuedraggable";
import _ from "lodash";
import { mapState } from "vuex";
import InputSubirImagen from "../../components/admin/InputSubirImagen.vue";
import traduccionesDialog from "../../components/admin/TraduccionesDialog.vue";

export default {
  data() {
    return {
      tab: 0,
      configuracion: {
        dominios: [],
        router: "",
        gtag: "",
        pixelFb: "",
        pixelTiktok: "",
      },
      general: {
        favicon: "",
        bolsaCarrito: "",
        colorFooter: "",
        colorMenuUser: "",
        darkDrawer: false,
        darkFooter: false,
        darkHeader: false,
        darkMenuUser: false,
        fondoDrawer: "",
        fondoDrawerImagen: "",
        fondoHeader: "",
        logoCentro: "",
        logoIzquierda: "",
        menuUserActivoClases: "",
        nombreFooter: "",
        seo: {
          ogtitle: "",
          ogtype: "",
          robot: "",
          titleTemplate: "",
          sitemap: "",
        },
        redesSociales: {
          facebook: "",
          twitter: "",
          instagram: "",
          tiktok: "",
          youtube: "",
        },
        msjInicial: {
          mostrar: false,
          titulo: "",
          texto: "",
        },
      },
      home: {
        seccion1: {
          mostrar: false,
          slider: {
            slide1: "",
            slide2: "",
            slide3: "",
            slide4: "",
            slide5: "",
          },
          imagenSobreBotones: "",
          botones: [],
          botonColorTexto: "",
          botonColorFondo: "",
          textoAccion: "",
          estiloImagen: "", //background-image: linear-gradient(to right, rgba(5, 11, 31, 0.6), rgba(5, 11, 31, 0.6))"
        },
        seccion2: {
          mostrar: false,
          imagen: "",
        },
        seccion3: {
          mostrar: false,
          imagen: "",
        },
        seccion4: {
          mostrar: true,
          imagen: "",
          colorFondo: "#ffffff",
        },
        seccion5: {
          mostrar: false,
          titulo: "",
          subtitulo: "",
          arrayImagenes: [], //{nombre, imagenUrl, enlace}
        },
        seccion6: {
          mostrar: false,
          titulo: "",
          subtitulo: "",
          nombreInstagram: "",
        },
        seccion7: {
          mostrar: false,
          titulo: "",
          subtitulo: "",
          listadoImagenes: [],
        },
        seo: {
          title: "",
          description: "",
        },
      },
      pedir: {
        bolsaCarritoCategoriasImagen: "",
        fondoImagen: "",
        fondoColor: "",
        seo: {
          title: "",
          description: "",
        },
      },
      domicilio: {
        seo: {
          title: "",
          description: "",
        },
      },
      recoger: {
        seo: {
          title: "",
          description: "",
        },
      },
      finalizar: {
        fondoFormasPago: "",
        logo: "",
        seo: {
          title: "",
          description: "",
        },
      },
      encuentranos: {
        activo: false,
        iconoMapa: "",
        imagenFondo: "",
        seo: {
          title: "",
          description: "",
        },
      },
      noticias: {
        activo: false,
        seo: {
          title: "",
          description: "",
        },
      },
      reservas: {
        activo: false,
        seo: {
          title: "",
          description: "",
        },
      },
      pwa: {
        titulo: "",
        descripcion: "",
        logo: "",
        colorFondo: "",
        colorTema: "",
        splash: {
          iphone5: "",
          iphone6: "",
          iphoneplus: "",
          iphonex: "",
          iphonexr: "",
          iphonexsmax: "",
          ipad: "",
        },
      },
      mostrarToolImagenes: 0, //se utiliza en array de imágenes de hoome sponsor
      headersPaginas: [
        {
          sortable: false,
          text: "Titulo",
          value: "titulo",
          width: "20%",
        },
        {
          sortable: false,
          text: "Descripcion",
          value: "descripcion",
          width: "65%",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          width: "15%",
        },
      ],
      imagenAux: null, //para subir imágenes
      loadingImagenAux: false,
      loadingForm: false,
      loadingActivo: false,
      loadingEliminar: false,
    };
  },
  watch: {},
  components: {
    draggable,
    traduccionesDialog,
    InputSubirImagen,
  },
  computed: {
    valoresTraducir() {
      let traducir = this.keyTraducir.map((k) => {
        return {
          key: k,
          texto: getValue(this, k),
        };
      });
      return traducir;
    },
    keyTraducir() {
      return [
        "general.msjInicial.texto",
        "general.msjInicial.titulo",
        "general.seo.titleTemplate",
        "general.seo.ogtitle",
        "home.seccion1.textoAccion",
        "home.seccion6.botonTexto",
        "home.seccion3.h1",
        "home.seccion3.h2",
        "home.seccion3.h4",
        "home.seccion5.titulo",
        "home.seccion5.subtitulo",
        "home.seccion6.titulo",
        "home.seccion6.subtitulo",
        "home.seccion7.titulo",
        "home.seccion7.subtitulo",
        "home.seo.description",
        "home.seo.title",
        "pedir.seo.description",
        "pedir.seo.title",
        "domicilio.seo.description",
        "domicilio.seo.title",
        "recoger.seo.description",
        "recoger.seo.title",
        "finalizar.seo.description",
        "finalizar.seo.title",
        "encuentranos.seo.description",
        "encuentranos.seo.title",
        "noticias.seo.description",
        "noticias.seo.title",
      ];
    },
    datosGeneralesDominios: {
      get() {
        return this.configuracion.dominios
          ? this.configuracion.dominios.toString()
          : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.configuracion.dominios = val.split(expresionRegular);
      },
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      plantillasDisponibles: (state) => state.propio.plantillasDisponibles,
      negocioObjBruto: (state) => state.app.negocioObjGest,
      directorioObjBruto: (state) => state.app.directorioObjGest,
      negocioGest: (state) => state.app.negocioGest,
      directorioGest: (state) => state.app.directorioGest,
    }),

    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    negocioObj() {
      return this.negocioGest
        ? this.negocioObjBruto
        : this.directorioObjBruto
        ? this.directorioObjBruto
        : null;
    },
    paginasDinamicas() {
      return this.negocioObj.web && this.negocioObj.web.paginasDinamicas
        ? this.negocioObj.web.paginasDinamicas
        : [];
    },
  },
  methods: {
    camposTraducidos(r) {
      r.forEach((trad) => {
        _.set(this, trad.value, trad.texto);
      });
    },

    //idiomapara las varaibles que lo requieran
    valorVariableIdioma(v) {
      var valor = _.get(this, v, "");
      if (!Array.isArray(valor)) {
        let str = valor;
        valor = this.idiomas.map((lang) => {
          return {
            lang: lang.value,
            text: lang.value === this.langDefecto ? str : "",
          };
        });
        _.set(this, v, valor);
      }
      var found = valor
        ? valor.find((e) => e.lang === this.langSeleccionado)
        : false;
      return found ? found.text : "";
    },
    valorVariableIdiomaCambio(v, key) {
      var valor = _.get(this, key);
      let fIndex = valor.findIndex((l) => l.lang === this.langSeleccionado);
      if (fIndex > -1) {
        valor[fIndex].text = v;
      }
      _.set(this, key, valor);
    },
    borrarArrayImagen(i) {
      if (i > -1) {
        this.home.seccion5.arrayImagenes.splice(i, 1);
      }
    },
    eliminarBoton(item, seccion) {
      var index = this.home[seccion].botones.indexOf(item);
      this.home[seccion].botones.splice(index, 1);
    },
    addBoton(seccion) {
      this.home[seccion].botones && Array.isArray(this.home[seccion].botones)
        ? this.home[seccion].botones.push({
            texto: "",
            enlace: "",
          })
        : (this.home[seccion].botones = [
            {
              texto: "",
              enlace: "",
            },
          ]);
      console.log(this.home[seccion].botones);
    },
    goEdit(item) {
      if (this.$store.getters["app/esNegocio"]) {
        this.$router.push(
          "/admin/gest/" + this.negocioGest + "/web/dinamica/" + item.id
        );
      } else if (this.$store.getters["app/esDirectorio"]) {
        this.$router.push(
          "/admin/directorio/" +
            this.directorioGest +
            "/web/dinamica/" +
            item.id
        );
      }
    },
    deleteItem(item) {
      this.$confirm("¿Desea eliminar la página? Esta acción es irreversible?", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      }).then((r) => {
        if (r) {
          let _vm = this;
          let paginasAux = this.paginasDinamicas;
          let foundIndex = paginasAux.findIndex((p) => p.id == item.id);
          if (foundIndex > -1) {
            item.activo = !item.activo;
            //paginasAux[foundIndex] = item;
            paginasAux.splice(foundIndex, 1);
            _vm.loadingEliminar = true;
            _vm.$store
              .dispatch("propio/savePaginaDinamica", paginasAux)
              .then((r) => {
                _vm.$store.commit("snackbar/setMensajeSuccess", {
                  msj: "Página eliminada",
                });
                return this.getNegDirGest();
              })
              .catch((error) => {
                _vm.$store.commit("snackbar/setMensajeDanger", {
                  msj: "Error al eliminar la página: " + error,
                });
              })
              .finally(() => {
                _vm.loadingEliminar = false;
              });
          } else {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "No se encuentra la página",
            });
          }
        }
      });
    },
    getNegDirGest() {
      if (this.$store.getters["app/esNegocio"]) {
        return this.$store.dispatch("negocios/getNegocioBoss");
      } else if (this.$store.getters["app/esDirectorio"]) {
        return this.$store.dispatch("directorios/getDirectorioGest");
      }
    },
    cambiarActivo(item) {
      let _vm = this;
      let paginasAux = this.paginasDinamicas;
      let foundIndex = paginasAux.findIndex((p) => p.id == item.id);
      if (foundIndex > -1) {
        item.activo = !item.activo;
        paginasAux[foundIndex] = item;
        _vm.loadingActivo = true;
        _vm.$store
          .dispatch("propio/savePaginaDinamica", paginasAux)
          .then((r) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Página cambiada",
            });
            return this.getNegDirGest();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar la página: " + error,
            });
          })
          .finally(() => {
            _vm.loadingActivo = false;
          });
      } else {
        _vm.$store.commit("snackbar/setMensajeDanger", {
          msj: "No se encuentra la página",
        });
      }
    },
    goAddPagina() {
      if (this.$store.getters["app/esNegocio"]) {
        this.$router.push("/admin/gest/" + this.negocioGest + "/web/dinamica");
      } else if (this.$store.getters["app/esDirectorio"]) {
        this.$router.push(
          "/admin/directorio/" + this.directorioGest + "/web/dinamica"
        );
      }
    },
    async generarSitemap() {
      console.log(this.configuracion.idiomas);
      console.log(this.paginasDinamicas);

      var s = await this.$store.dispatch("propio/generarSitemap", {
        idiomas: !!this.configuracion.idiomas
          ? this.configuracion.idiomas
          : ["es"],
        dinamicas: !!this.paginasDinamicas ? this.paginasDinamicas : [],
      });
      this.general.seo.sitemap = s;
      this.$forceUpdate();
    },
    save() {
      const _vm = this;
      _vm.loadingForm = true;
      this.$store
        .dispatch("propio/saveDatosGenerales", {
          ..._vm.configuracion,
          general: this.general,
          home: this.home,
          pedir: this.pedir,
          domicilio: this.domicilio,
          recoger: this.recoger,
          finalizar: this.finalizar,
          encuentranos: this.encuentranos,
          noticias: this.noticias,
          reservas: this.reservas,
          pwa: this.pwa,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Datos de web propia guardados",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los datos: " + error,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
    generarManifest() {
      let _vm = this;
      _vm.loadingForm = true;
      return _vm.$store
        .dispatch("propio/generarManifest", {
          imagen: this.pwa.logo,
          negocio: this.negocioObj.id,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Datos de web propia guardados",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los datos: " + error,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
    imagenSubidaPwaSplash(v, prop) {
      this.pwa.splash[prop] = v;
    },
    cambiarImagen(s) {
      this.imagenCambiando = s;
      this.$refs[s].$refs.input.click();
    },
    cambiarImagenFichero(pagina = false) {
      let _vm = this;
      _vm.loadingImagenAux = true;
      this.$store
        .dispatch("propio/subirImagen", {
          //tipo: this.imagenCambiando,
          imagen: this.imagenAux,
        })
        .then((img) => {
          if (pagina) {
            const array = pagina.split("/");
            let aux = this;
            array.forEach((e) => {
              aux = aux[e];
            });
            if (Array.isArray(aux[this.imagenCambiando])) {
              aux[this.imagenCambiando].push({
                imagenUrl: img,
              });
            } else {
              aux[this.imagenCambiando] = img;
            }
          } else {
            this.general[this.imagenCambiando] = img;
          }
        })
        .finally(() => (_vm.loadingImagenAux = false));
    },
  },
  mounted() {
    if (this.$store.getters["app/esNegocio"]) {
    } else if (this.$store.getters["app/esDirectorio"]) {
      //se gestiona directorio
    }
    this.configuracion.dominios = this.negocioObj.dominios
      ? this.negocioObj.dominios
      : [];
    if (this.negocioObj.web) {
      this.configuracion.router = this.negocioObj.web.router;
      this.configuracion.gtag = this.negocioObj.web.gtag
        ? this.negocioObj.web.gtag
        : "";
      this.configuracion.pixelFb = this.negocioObj.web.pixelFb
        ? this.negocioObj.web.pixelFb
        : "";
      this.configuracion.pixelTiktok = this.negocioObj.web.pixelTiktok
        ? this.negocioObj.web.pixelTiktok
        : "";
      this.configuracion.idiomas = this.negocioObj.web.idiomas
        ? this.negocioObj.web.idiomas
        : [];
      this.general = this.negocioObj.web.general;
      this.home = this.negocioObj.web.home;
      this.pedir = this.negocioObj.web.pedir;
      this.finalizar = this.negocioObj.web.finalizar;
      this.pwa = this.negocioObj.web.pwa;
      if (this.negocioObj.web.encuentranos)
        this.encuentranos = this.negocioObj.web.encuentranos;

      if (this.negocioObj.web.noticias)
        this.noticias = this.negocioObj.web.noticias;
      if (this.negocioObj.web.reservas)
        this.reservas = this.negocioObj.web.reservas;
    }

    if (!this.pwa) {
      this.pwa = {
        titulo: "",
        descripcion: "",
        logo: "",
        colorFondo: "",
        colorTema: "",
        splash: {
          iphone5: "",
          iphone6: "",
          iphoneplus: "",
          iphonex: "",
          iphonexr: "",
          iphonexsmax: "",
          ipad: "",
        },
      };
    }
    if (!this.pwa.splash) {
      this.pwa.splash = {
        iphone5: "",
        iphone6: "",
        iphoneplus: "",
        iphonex: "",
        iphonexr: "",
        iphonexsmax: "",
        ipad: "",
      };
    }
    if (!this.general) this.general = {};
    if (!this.general.seo) {
      this.general.seo = {
        ogtitle: "",
        ogtype: "",
        robot: "",
        titleTemplate: "",
        sitemap: "",
      };
    }
    if (!this.general.redesSociales) {
      this.general.redesSociales = {
        facebook: "",
        twitter: "",
        instagram: "",
        tiktok: "",
        youtube: "",
      };
    }
    if (!this.general.msjInicial) {
      this.general.msjInicial = {
        mostrar: false,
        titulo: "",
        texto: "",
      };
    }

    if (!this.home) this.home = {};
    if (!this.home.seccion1) {
      this.home.seccion1 = {
        mostrar: false,
        slider: {
          slide1: "",
          slide2: "",
          slide3: "",
          slide4: "",
          slide5: "",
        },
        botonColorTexto: "",
        botonColorFondo: "",
        textoAccion: "",
        estiloImagen: "",
      };
    }
    if (!this.home.seccion2) {
      this.home.seccion2 = {
        mostrar: false,
        imagen: "",
      };
    }
    if (!this.home.seccion3) {
      this.home.seccion3 = {
        mostrar: false,
        imagen: "",
      };
    }
    if (!this.home.seccion3.botones) this.home.seccion3.botones = [];
    if (!this.home.seccion4) {
      this.home.seccion4 = {
        mostrar: true,
        imagen: "",
        colorFondo: "#ffffff",
      };
    }
    if (!this.home.seccion5) {
      this.home.seccion5 = {
        mostrar: false,
        titulo: "",
        subtitulo: "",
        arrayImagenes: [], //{nombre, imagenUrl, enlace}
      };
    }
    if (!this.home.seccion6) {
      this.home.seccion6 = {
        mostrar: false,
        titulo: "",
        subtitulo: "",
        nombreInstagram: "",
      };
    }
    if (!this.home.seccion7) {
      this.home.seccion7 = {
        mostrar: false,
        titulo: "",
        subtitulo: "",
        listadoImagenes: "",
      };
    }
    if (!this.home.seo) {
      this.home.seo = {
        title: "",
        description: "",
      };
    }

    if (!this.pedir || !this.pedir.seo) {
      this.pedir = {
        seo: {
          title: "",
          description: "",
        },
      };
    }

    if (!this.finalizar || !this.finalizar.seo) {
      this.finalizar = {
        seo: {
          title: "",
          description: "",
          fondoFormasPago: "",
        },
      };
    }

    if (this.negocioObj.web && this.negocioObj.web.domicilio) {
      if (this.negocioObj.web.domicilio.seo) {
        this.domicilio.seo = this.negocioObj.web.domicilio.seo;
      }
    }
    if (this.negocioObj.web && this.negocioObj.web.recoger) {
      if (this.negocioObj.web.recoger.seo) {
        this.recoger.seo = this.negocioObj.web.recoger.seo;
      }
    }
  },
};
</script>

<style>
</style>